export default function formatter(reviews) {
  return reviews.map(review => {
    const name = review.user.name.substring(0, 1)
    review.$reviewerName = `${name}****`
    review.$rating = review.rating
    review.$largePhotos = review.photos.map(photo => photo.url.large)
    if (!review.booking) return review
    const { bookingDiscount, services } = review.booking
    if (bookingDiscount?.campaign) {
      review.$serviceText = bookingDiscount.campaign.name
      return review
    }
    review.$serviceText = services.map(({ service }) => service.name).join(', ')
    return review
  })
}
